import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BaseMediaClientError } from '../../models/errors';
export var FileFetcherError = /*#__PURE__*/function (_BaseMediaClientError) {
  _inherits(FileFetcherError, _BaseMediaClientError);
  var _super = _createSuper(FileFetcherError);
  function FileFetcherError(reason, id, metadata) {
    var _this;
    _classCallCheck(this, FileFetcherError);
    _this = _super.call(this, reason);
    _this.reason = reason;
    _this.id = id;
    _this.metadata = metadata;
    return _this;
  }
  _createClass(FileFetcherError, [{
    key: "attributes",
    get: function get() {
      var reason = this.reason,
        id = this.id,
        _this$metadata = this.metadata,
        _this$metadata2 = _this$metadata === void 0 ? {} : _this$metadata,
        collectionName = _this$metadata2.collectionName,
        occurrenceKey = _this$metadata2.occurrenceKey,
        traceContext = _this$metadata2.traceContext;
      return _objectSpread({
        reason: reason,
        id: id,
        collectionName: collectionName,
        occurrenceKey: occurrenceKey
      }, traceContext && {
        metadata: {
          traceContext: traceContext
        }
      });
    }
  }]);
  return FileFetcherError;
}(BaseMediaClientError);
export function isFileFetcherError(err) {
  return err instanceof FileFetcherError;
}